/** Decorative rings only: no logo changes, interaction, or additional data. */
export default function MotionHalo() {
  return (
    <span aria-hidden="true" data-gp-reveal="halo" className="gp-motion-halo" />
  );
}
